import m from "../../geodata/es2015/svalbardHigh";
window.am4geodata_svalbardHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/svalbardHigh.js
// module id = null
// module chunks = 